<template>
	<div class="l-body">
	<Top/>
	<div class="wrap" :class="bgId">
	  <div class="l-wrap zheng">
	    <div class="faqtit"><span id="game">{{game}}</span><span>-</span><span id="faqtype">违规举报</span></div>
	    <div class="help-menu-box">
	      <div class="st_trees">
	        <ul class="tree_a">
			  <li><a>违规举报</a></li>
	        </ul>
	      </div>
	    </div>
		  <div class="help-jl-box">
		  <h1>当前正在进行违规举报</h1>
		  <div class="xiangxi">
			  <table class="biaogea">
			  <tr>
			  <th width="23%">请选择服务器（区）：</th>
			  <td width="77%"><div>
			  <el-select v-model="gameserver" style="width:320px">
			      <el-option v-for='item in gameData' :label="item.info" :value="item.info" :key="item.info"></el-option>
			  </el-select>
			  </div></td>
			  </tr>
			  <tr>
			  <th>游戏线路：</th>
			  <td>
			  <div>
			  <input class="text" id="mobile" name="mobile" type="text" placeholder="请输入被举报角色所在的线路" v-model="gameline">
			  </div>
			  </td>
			  </tr>
			  <tr>
			  <th>角色名：</th>
			  <td>
			  <div>
			  <input class="text" id="mobile" name="mobile" type="text" placeholder="请输入被举报角色名" v-model="role">
			  </div>
			  </td>
			  </tr>
			  <tr>
			  <th>所在地图：</th>
			  <td>
			  <div>
			  <input class="text" id="mobile" name="mobile" type="text" placeholder="请输入被举报角色所在的地图" v-model="gamemap">
			  </div>
			  </td>
			  </tr>
			  <tr>
			  <th> 外挂特征：</th>
			  <td>
			  <div>
			  <input class="text" id="mobile" name="mobile" type="text" placeholder="请输入外挂特征" v-model="plug">
			  </div>
			  </td>
			  </tr>
			  <tr>
			  <th>请输入联系邮箱：</th>
			  <td>
			  <div>
			  <input class="text" id="email" name="email" type="text" placeholder="请输入联系邮箱" v-model="email">
			  </div>
			  </td>
			  </tr>
			  <tr>
			  <th valign="top" style="padding-top:10px;">其他说明：</th>
			  <td><div>
			  <textarea name="added" cols="58" rows="5" placeholder="请输入其他说明" v-model="other"></textarea>
			  </div></td>
			  </tr>
			  <tr>
			  <th></th>
			  <td class="anniua" ><a @click="shou" style="text-align: center;">提交</a></td>
			  </tr>
			  </table>
		  </div>
		    <div class="hujiao">
		      <p>您的问题是否得到了解决？如果没有，您可以尝试：</p>
		      <p>呼叫在线客服：<a href='http://wpa.b.qq.com/cgi/wpa.php?ln=1&key=XzgwMDEwMzM3N180NTIzMjdfODAwMTAzMzc3XzJf'>在线客服</a></p>
		    </div>
		  </div>
	  </div>
	</div>
	</div>
</template>

<script>
import Top from '@/components/top.vue'
  export default {
    name: "complain1",
    components: {
      Top
    },
	data () {
	  return {
	    id:this.$route.query.id,
	    game:this.$route.query.name,
	    bgId:'',
		choose:'',
		gameData:[],
		gameserver: '',
		gameline: '',
		role: '',
		gamemap: '',
		plug: '',
		email: '',
		other: ''
	  }
	},
	created() {
	  this.gameBg()
	  this.getgameQ()
	},
	methods:{
	  gameBg(){
	    if(this.id==1){
	      this.bgId='sun'
		  //this.sun=true
		  this.show=true
	    }else if(this.id==2){
	      this.bgId='mu'
		  //this.mu=true
		  this.show=true
	    }else if(this.id==4){
	      this.bgId='ro'
		  //this.ro=true
		  this.show=true
	    }else if(this.id==5){
	      this.bgId='moli'
		  this.show=true
	    }else if(this.id==3){
	      this.bgId='mu2'
	    }
	  },
	  getgameQ(){
	  		this.$axios({
	  		  method: 'get',
	  		  url: '/index.php/user/User/gameinfo',
	  		  params: {
	  			id:this.id,
	  		  }
	  		}).then(res => {
	  		  if(res.data.status==200){
	  			this.gameData=res.data.data
	  		  }else{
	  			this.gameData=[]
	  		  }
	  		})
	  },
	  shou(){
		if(this.gameserver==''){
			this.$message({
				type: 'error',
				message:'服务器必须选择',
				offset:300
			});
			return false;
		}
		if(this.gameline==''){
			this.$message({
				type: 'error',
				message:'游戏线路必须填写',
				offset:300
			});
			return false;
		}
		if(this.role==''){
			this.$message({
				type: 'error',
				message:'角色名必须填写',
				offset:300
			});
			return false;
		}
		if(this.gamemap==''){
			this.$message({
				type: 'error',
				message:'所在地图必须填写',
				offset:300
			});
			return false;
		}
		if(this.plug==''){
			this.$message({
				type: 'error',
				message:'外挂特征必须填写',
				offset:300
			});
			return false;
		}
		if(this.email==''){
			this.$message({
				type: 'error',
				message:'联系邮箱必须填写',
				offset:300
			});
			return false;
		} 
		let flag= /^[A-Za-z0-9\u4e00-\u9fa5_]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/.test(this.email)
        if(!flag){
			this.$message({
				type: 'error',
				message:'邮箱格式错误',
				offset:300
			});
			return false 
        }
		this.$axios({
		  method: 'post',
		  url: '/index.php/user/User/report',
		  data: {
			game:this.game,
			gameserver:this.gameserver,
			gameline:this.gameline,
			role:this.role,
			gamemap:this.gamemap,
			plug:this.plug,
			email:this.email,
			other:this.other
		  }
		}).then(res => {
		  console.log(res)
		  if(res.data.status == 200){
			this.$alert('举报信息提交成功，一旦核实到该角色有违规异常情况会按相应规则进行处理，请关注近期官网的外挂封停名单。', {
				confirmButtonText: '确定',
			});
			this.gameserver=''
			this.gameline=''
			this.gamemap=''
			this.plug=''
			this.email=''
			this.other=''
			this.role=''
		  }
		})
	  }
	}
}
</script>

<style scoped>
    .fixwidth{display: inline-block;margin:25px 0}
    .width{width:320px}
    #applyBox textarea{width:350px!important;}
    .delAll{font-size:32px;position: absolute;right:20px;top:20px}
  .submitBtnPanel{color:#fff;}
  .rediotip{line-height:1.5;font-size:12px;margin:5px 20px 5px 0px;color:#c25205;width:350px}
</style>



// WEBPACK FOOTER //
// src/components/complain1.vue